// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuerySortActions_wrapper__26_Qi","active":"QuerySortActions_active__2wBcr"};